import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import * as XLSX from 'xlsx';
import Container from "@mui/material/Container";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import * as FileSaver from 'file-saver';
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import currencySymbolMap from "currency-symbol-map";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppraisalReviewServiceURL } from "../../../config/config";
import {
  DataGridPro,
  GridActionsCellItem,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridSortModel,
  GridFilterItem,
  GridHeaderFilterCellProps,
  GridRowSelectionModel,
  GridDeleteIcon,
  useGridApiRef,
  gridExpandedSortedRowIdsSelector,
  gridVisibleColumnDefinitionsSelector,
  getGridStringOperators,
  GridRowClassNameParams,
} from "@mui/x-data-grid-pro";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { GridFilterModel } from "@mui/x-data-grid";
import { ServiceName } from "../../../constants";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppSelector } from "../../../redux/hooks";
import LoadingButton from "@mui/lab/LoadingButton";
import { Autocomplete, InputAdornment, ListItemText, ListSubheader, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DeleteForever, DeleteOutline, DeleteSweep, Today } from "@mui/icons-material";
import { AlertDialog } from "components/util/Dialog";
import { ToastMessage } from "components/util/ToastMessage";
import { wait } from "@testing-library/user-event/dist/utils";
import dayjs from "dayjs";
import { useResizeDetector } from "react-resize-detector";
import { UserContext } from "redux/slices/userContextSlice";

const containsText = (text: any, searchText: any) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

export const USAppraisalDashboardList = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("My Appraisals");
  const [searchText, setSearchText] = useState("");
  const [params, setParams] = useState("");
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const AppraisalViewName = React.useRef("");
  const exportToExcel = React.useRef("no");
  const sortColumn = React.useRef("");
  const sortColumnType = React.useRef("");
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [exportLoadingButton, setExportLoadingButton] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [usAppraisal, setUsAppraisal] = useState<any[]>([]);
  const [usAppraisalFilter, setUsAppraisalFilter] = useState<any>({});
  const [appraisalView, setAppraisalView] = useState<any[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<any>({});
  const [pageSize, setPageSize] = useState<number>(10);
  const [sortingField, setSortingField] = useState<string>("");
  const [sortType, setSortType] = useState<number>(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [rowSelectionModel, setRowSelectionModel] = useState<GridRowSelectionModel>([]);

  const singleDelete = React.useRef(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [toBeDeleteId, setToBeDeleteId] = useState<string>("");
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const apiRef = useGridApiRef();
  const { width, ref } = useResizeDetector();
  const [columnWidths, setColumnWidths] = useState<any>({});
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );
  useEffect(() => {
    if (width) {
      const newColumnWidths = {
        column1: width * 0,
        column2: width * 0.1,
        column3: width * 0.11
      };
      setColumnWidths(newColumnWidths);
    }
  }, [width]);

  const viewNameAndId: { [key: string]: string } = {
    "My Appraisals": "f8150d5b-a0cb-4625-aa63-c89049b841f1",
    "My Posted Appraisals" : "fff7c3fa-32f4-4c95-a3b1-a528f4ec6b10",
    "Current Month - Posted Appraisals" : "8f50d1e1-6b2a-42fc-9ec7-50c15586ec76",
    "Scheduled Appraisals" : "943453f0-fc46-4ab2-91a1-75bab8cf9866",
    "All Posted Appraisals" : "32da3f91-0380-4cd7-867d-6f89cf820d46",
    "All Appraisals" : "f638a648-75da-46d5-91e9-143cbd2e5af9",
    "Accounting" : "cf4d3531-8f4d-472c-a59f-65b5af7eac9e",
    "To be Archived Appraisals" : "3cb6aeac-a605-419d-824d-2c88c58fbbc8"   
  }


  // React.useEffect(() => {
  //   apiRef.current.autosizeColumns({includeHeaders:true,includeOutliers:true});
  //   console.log("hello world");
  // },[apiRef,usAppraisal]);

  const getFormatedDate = (date: any) => {
    return date.value !== '' && date.value !== null ? dayjs(date.value, "MM-DD-YYYY hh:mm:ss").format("MMM-DD-YYYY") : '';
  }

  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    setLoading(true);
    if (appraisalView?.length == 0) {
      await GetUsAppraisalsView(paginationModel, filterModel).then(
        (data: any) => {
          // console.log(data?.result?.appraisals)
          console.log("fetching")
          setUsAppraisal(data?.result?.appraisals);
          setUsAppraisalFilter(data?.result?.appraisalsFiters);
          setRowCount(data.result.rowCount);
        }
      ).catch((e) => {
        console.log(e);

      }).finally(() => {
        setLoading(false);
      });
    }
    else {
      await GetUsAppraisals(paginationModel, filterModel).then(
        (data: any) => {
          console.log(data?.result?.appraisals)
          setUsAppraisal(data?.result?.appraisals);
          setUsAppraisalFilter(data?.result?.appraisalsFiters);
          setRowCount(data.result.rowCount);
        }
      ).catch((e) => {
        console.log(e);

      }).finally(() => {
        setLoading(false);
      });
    }
  };

  const GetUsAppraisalsView = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var appraisalViewArr: any[] = [];
    if (appraisalView?.length == 0) {
      var appraisalViewURL = AppraisalReviewServiceURL + "/appraisals/Views?emailAddress=" + currentUserData?.email?.toLowerCase();
      await getApiCall(appraisalViewURL, ServiceName.APPRAISALREVIEW).then((appraisalView: any) => {
        appraisalViewArr = appraisalView?.result.map((appraisalView: any) => <Tab label={appraisalView.displayName} value={appraisalView.displayName} key={appraisalView.id} id={appraisalView.id} sx={{ textTransform: 'capitalize' }} />
        );
        setAppraisalView(appraisalViewArr);
        var sessionView = sessionStorage.getItem("SessionUSAppraisalDashboardView");
        if (sessionView !== null) {
          AppraisalViewName.current = sessionView;
        } else {
          AppraisalViewName.current = (appraisalView?.result[0]?.displayName);
        }
      });
      return await GetUsAppraisals(paginationModel, filterModel);
    }
  }

  const GetUsAppraisals = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var appraisalsArr: any[] = [];
    appraisalsArr = filterModel?.items?.map((appraisalsFilter: any) => {
      // if (appraisalsFilter?.value !== undefined && appraisalsFilter?.value != "Select an option...") { // to clear filter
      if (appraisalsFilter?.value !== undefined) {
        return {
          identity: appraisalsFilter?.field,
          matchMode: "in",
          value: appraisalsFilter?.value,
        };
      }
      return {}
    });

    // appraisalsArr.filter((filter:any) => Object.keys(filter).length > 0);// to clear filter

    var url = AppraisalReviewServiceURL + "/Appraisals/GetAppraisalsByViewIdAndFilters";

    var lazyLoadEventparameter = {
      filters: appraisalsArr,
      first: paginationModel.pageSize * paginationModel.page,
      rows: paginationModel.pageSize,
      sortOrder: sortColumnType.current,
      sortField: sortColumn.current,
      filterConditionalOperator: filterModel?.logicOperator,
    };
    var payload = {
      lazyLoadEventparam: lazyLoadEventparameter,
      viewName: AppraisalViewName.current,
      applicationUserEmail: currentUserData.email
    }
    return await postApiCall(url, payload, "AppraisalReviewService").then((data: any) => data);

  };

  // useEffect(() => {
  //   // fetchData(paginationModel, filterModel);
  //   // localStorage.getItem()
  //   console.log("use effect", paginationModel, filterModel)
  // }, [paginationModel, filterModel]);


  const ITEM_HEIGHT = 24;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP,
        width: 250,
      },
      autoFocus: false,
    },
  };

  const handleFilterChange = (e: any, field: string,reason:string) => {
    console.log(e, field);
    const value = reason == "removeOption" ? e : selectedOptions[field];    
    // setSelectedOptions({
    //   ...selectedOptions, ...{
    //     [field]: value
    //   }
    // });
    const multiSelectFilter: GridFilterItem = {
      field: field,
      value: value || "",
      operator: "contains"
    }
    filterModel.items = filterModel.items.filter(f => f.field !== field);
    filterModel.items.push(multiSelectFilter);
    setFilterModel(filterModel);
    localStorage.setItem(AppraisalViewName.current, JSON.stringify(filterModel));
    fetchData(paginationModel, filterModel);
    setSearchText("");
  }

  const customHeaderFilter = (params: GridHeaderFilterCellProps) => {
    var onChangeFilterValue = "";
    const columnFilterList = usAppraisalFilter[params.item.field]?.sort() || [];

    // console.log("inside filter option function: ");
    // console.log(params.item,">>>",usAppraisalFilter[params.item.field] )
    var copyColumnFilterList = [...columnFilterList];
    // console.log(copyColumnFilterList);

    if (params.item.field === 'valueDate' || params.item.field === 'postedAppraisalDate'
      || params.item.field === 'nextAppraisalDate' || params.item.field === 'created' || params.item.field === 'sendToAccountingDate') {
      copyColumnFilterList = copyColumnFilterList?.map((value: string) => {
        return value !== "" && value !== null ? dayjs(value, "MM-DD-YYYY hh:mm:ss").format("MMM-YYYY") : ''
      });
      copyColumnFilterList = copyColumnFilterList.filter((value, index, self) => self.indexOf(value) === index).sort();
    }


    // copyColumnFilterList.unshift('Select an option...');// to clear filter

    const displayedOptions = copyColumnFilterList.filter((option: any) => {
      if (!!searchText?.trim()?.length) {
        return option?.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
      } else {
        return option;
      }
    })
    return (
      <Autocomplete
      ChipProps={{
          sx: {
            "margin": "3px",
            "max-width": "calc(60% - 6px)"
        },
      }}
      multiple
      limitTags={1}
      id="tags-standard"
      options={displayedOptions}
      sx={{ width: 300 , maxWidth: "100%"}}

      onChange={(event, newValue,reason) => {
        onChangeFilterValue = newValue.toString();
        if (reason === "removeOption") {
          handleFilterChange(onChangeFilterValue, params.item.field,"removeOption");
        }
        setSelectedOptions({
          ...selectedOptions, ...{
            [params.item.field]: newValue.toString()
          }
        });
      }}
      onBlur={() => {
        handleFilterChange(onChangeFilterValue, params.item.field,"");

      }}
      value={selectedOptions.hasOwnProperty(params.item.field) && selectedOptions[params.item.field] ? selectedOptions[params.item.field].split(',') : []}
      onClick={(event: any) => {
        event.stopPropagation()
      }}
      renderInput={(params) => (
        <TextField sx={{ fontSize:"8px"}}
          {...params}
          onKeyDown={(e) => {
            if (e.key !== "Escape") {
              e.stopPropagation();
            }
          }}
          variant="standard"
          label=""
          placeholder=""
        />
      )}
    />
    )
  }

  const formatNumber = (params: any) => {
    var currencySymbol: string = '$'
    if (params.row.currency != "") {
      currencySymbol = currencySymbolMap(params.row.currency) as string;
    }

    if (currencySymbol == undefined) {
      currencySymbol = '$';
    }
    if (params.value !== null)
      return <div style={{ textAlign: 'right', width: '100%' }}>
        {currencySymbol + ' ' + params.value.toLocaleString('en-US')}
      </div>
        ;
  }

  const columnsMyAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status",
      headerName: "Review Status",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "investmentId",
      headerName: "Investment ID",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "investmentName",
      headerName: "Investment Name",

      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType",
      headerName: "Property Type",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate,
      width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber,
      width: columnWidths.column3 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiser2Name", headerName: "Appraiser 2", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ),
      width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date",
      renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];

  const columnsAllAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiser2Name", headerName: "Appraiser 2", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];

  const columnsMyPostedAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];


  const columnsAccounting: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiserFirm", headerName: "Appraiser Firm", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100,
    },
    {
      field: "lastAnnualAppraisedValue", headerName: "Annual Value", filterable: false, renderCell: formatNumber, width: columnWidths.column2 || 100
    },
    {
      field: "annualPercentageChange", headerName: "% Change from Annual Value", filterable: false, width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "if", headerName: "If", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "scheduleNCost", headerName: "Schedule - N", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "derivative", headerName: "Derivative", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    }

  ];

  const columnsCurrentMonthPostedAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];

  const columnsAllPostedAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "assetManagerName", headerName: "Asset Manager", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiser2Name", headerName: "Appraiser 2", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];

  const columnsScheduledAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <GridActionsCellItem
                sx={{
                  color: "#253746",
                }}
                icon={<EditIcon />}
                label="Edit"
                onClick={(event) => {
                  onEditClick(event);
                }}
              />}
          </>
        );
      },
      width: columnWidths.column1 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "valueDate", headerName: "Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiser2Name", headerName: "Appraiser 2", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column2 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "postedAppraisalDate", headerName: "Date Posted", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "nextAppraisalDate", headerName: "Next Appraisal Date", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), renderCell: getFormatedDate, width: columnWidths.column2 || 100
    }
  ];

  const columnsToBeArchivedAppraisal: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/main/appraisal-form/" + "view/" + cellValues.id);
        };

        const onDeleteClick = (e: any) => {
          setToBeDeleteId(cellValues.id.toString());
          singleDelete.current = true;
          openConfirmBox();
          e.stopPropagation();
        }
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            {cellValues.row.canEdit &&
              <>
                <GridActionsCellItem
                  sx={{
                    color: "#253746",
                  }}
                  icon={<EditIcon />}
                  label="Edit"
                  onClick={(event) => {
                    onEditClick(event);
                  }}
                />
                <GridActionsCellItem
                  sx={{
                    color: "#253746",
                  }}
                  icon={<DeleteOutline />}
                  label="Delete & Archive"
                  onClick={(event) => {
                    onDeleteClick(event);
                  }}
                />
              </>
            }
          </>
        );
      }, width: columnWidths.column2 || 100
    },
    {
      field: "status", headerName: "Review Status", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentId", headerName: "Investment ID", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentName", headerName: "Investment Name", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentPropertyType", headerName: "Property Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "fund", headerName: "Fund", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "investmentType", headerName: "Investment Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraisalType", headerName: "Appraisal Type", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "appraiser1Name", headerName: "Appraiser 1", filterable: false, width: columnWidths.column2 || 100, renderHeaderFilter: customHeaderFilter
    },
    {
      field: "appraiserFirm", headerName: "Appraiser Firm", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "lastAnnualAppraisedValue", headerName: "Annual Value", filterable: false, renderCell: formatNumber, width: columnWidths.column2 || 100
    },
    {
      field: "annualPercentageChange", headerName: "% change from Annual Val", filterable: false, width: columnWidths.column2 || 100
    },
    {
      field: "currentAppraisalValue", headerName: "Current Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "lastAppraisedValue", headerName: "Last Value", filterable: false, renderCell: formatNumber, width: columnWidths.column3 || 100
    },
    {
      field: "sendToAccountingDate", headerName: "Date of Accounting", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "if", headerName: "If", renderHeaderFilter: customHeaderFilter,
      filterOperators: getGridStringOperators().filter(
        (operator) => operator.value === "contains"
      ), width: columnWidths.column2 || 100
    },
    {
      field: "scheduleNCost", headerName: "Schedule - N", filterable: false, renderCell: formatNumber, width: columnWidths.column2 || 100
    },
    {
      field: "derivative", headerName: "Derivative", filterable: false, renderCell: formatNumber, width: columnWidths.column2 || 100
    }
  ];


  const handelPaginationModel = (paginationModel: GridPaginationModel) => {
    setPaginationModel(paginationModel);
    console.log("reaching pagination");
    fetchData(paginationModel, filterModel);
  };

  const handelSortModelChange = (sortModel: GridSortModel) => {

    if (sortModel.length == 0) {
      sortColumn.current = "";
      sortColumnType.current = "0";
    }
    else {
      sortColumn.current = sortModel[0].field;
      if (sortModel[0].sort == 'asc') {
        sortColumnType.current = "1";
      }
      else {
        sortColumnType.current = "0";
      }
    }
    fetchData(paginationModel, filterModel);
  };


  const handelFilterModelChange = (filterModel: any) => {
    setFilterModel(filterModel);
    sessionStorage.setItem('sessionUSFilterObject', JSON.stringify(filterModel));
    fetchData(paginationModel, filterModel);
  };

  const cols = [
    { header: 'Review Status', field: 'Status', filterType: 'multi' },
    { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
    { header: 'Investment', field: 'InvestmentName', filterType: 'multi' },
    { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
    { header: 'Fund', field: 'Fund', filterType: 'multi' },
    { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
    { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
    { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
    { header: 'Appraisal Firm', field: 'AppraiserFirm', filterType: 'text' },
    { header: 'Annual Value', field: 'LastAnnualAppraisedValue', filterType: 'text', dataType: 'amount' },
    { header: '% Change from Annual Value', field: 'AnnualPercentageChange', filterType: 'text', dataType: 'percent' },
    { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
    { header: 'Current Principal Balance Value', field: 'CurrentPrincipalValue', filterType: 'text', dataType: 'amount' },
    { header: 'Loan to Value Ratio', field: 'LoanToValueRatio', filterType: 'text', dataType: 'percent' },
    { header: 'Treasury Rate', field: 'TreasuryRate', filterType: 'text', dataType: 'percent' },
    { header: 'RiskPremium', field: 'RiskPremium', filterType: 'text', dataType: 'text' },
    { header: 'Survey Yield', field: 'SurveyYield', filterType: 'text', dataType: 'percent' },
    { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
    { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
    { header: 'IF', field: 'IF', filterType: 'multi' },
    { header: 'Schedule - N', field: 'ScheduleNCost', filterType: 'text', dataType: 'amount' },
    { header: 'Derivative', field: 'Derivative', filterType: 'text', dataType: 'amount' },
    { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' }
  ];

  const getColumnsAsPerView = (viewName:string) =>{
    var columns:any[] = [];
    switch (viewName) {
      case "My Appraisals":
        //My Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },          
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
          { header: 'Appraiser2', field: 'Appraiser2Name', filterType: 'text' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' },
        ];
        break;
      case "My Posted Appraisals":
        //My Posted Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' }
        ];
        break;
      case "Current Month - Posted Appraisals":
        //Current Month - Posted Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' }
        ];
        break;
      case "Scheduled Appraisals":
        //Scheduled Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
          { header: 'Appraiser2', field: 'Appraiser2Name', filterType: 'text' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' }
        ];
        break;
      case "All Posted Appraisals":
        //All Posted Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Asset Manager', field: 'assetManagerName', filterType: 'multi' },
          { header: 'Appraiser 1', field: 'Appraiser1Name', filterType: 'multi' },
          { header: 'Appraiser 2', field: 'Appraiser2Name', filterType: 'multi' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' }
        ];
        break;
      case "All Appraisals":
        //All Appraisals
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Date', field: 'ValueDate', filterType: 'multi', dataType: 'date' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
          { header: 'Appraiser2', field: 'Appraiser2Name', filterType: 'text' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Date Posted', field: 'PostedAppraisalDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'Next Appraisal Date', field: 'NextAppraisalDate', filterType: 'multi', dataType: 'date' }
        ];
        break;
      case "Accounting":
        //Accounting
        columns = [
          { header: 'Review Status', field: 'Status', filterType: 'multi' },
          { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
          { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
          { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
          { header: 'Fund', field: 'Fund', filterType: 'multi' },
          { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
          { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
          { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
          { header: 'Appraisal Firm', field: 'appraiserFirm', filterType: 'text' },
          { header: 'Annual Value', field: 'lastAnnualAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: '% Change from Annual Value', field: 'annualPercentageChange', filterType: 'text', dataType: 'percent' },
          { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
          { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
          { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
          { header: 'IF', field: 'IF', filterType: 'multi' },
          { header: 'Schedule - N', field: 'ScheduleNCost', filterType: 'text', dataType: 'amount' },
          { header: 'Derivative', field: 'Derivative', filterType: 'text', dataType: 'amount' }
        ];
        break;
      case "To be Archived Appraisals":
          //Data older than 7 years
          columns = [
            { header: 'Review Status', field: 'Status', filterType: 'multi' },
            { header: 'Investment ID', field: 'InvestmentId', filterType: 'multi' },
            { header: 'Investment Name', field: 'InvestmentName', filterType: 'multi' },
            { header: 'Property Type', field: 'InvestmentPropertyType', filterType: 'multi' },
            { header: 'Fund', field: 'Fund', filterType: 'multi' },
            { header: 'Investment Type', field: 'InvestmentType', filterType: 'multi' },
            { header: 'Appraisal Type', field: 'AppraisalType', filterType: 'multi' },
            { header: 'Appraiser1', field: 'Appraiser1Name', filterType: 'text' },
            { header: 'Appraisal Firm', field: 'appraiserFirm', filterType: 'text' },
            { header: 'Annual Value', field: 'lastAnnualAppraisedValue', filterType: 'text', dataType: 'amount' },
            { header: '% Change from Annual Value', field: 'annualPercentageChange', filterType: 'text', dataType: 'percent' },
            { header: 'Current Value', field: 'CurrentAppraisalValue', filterType: 'text', dataType: 'amount' },
            { header: 'Last Value', field: 'LastAppraisedValue', filterType: 'text', dataType: 'amount' },
            { header: 'Date to Accounting', field: 'SendToAccountingDate', filterType: 'multi', dataType: 'datetime' },
            { header: 'IF', field: 'IF', filterType: 'multi' },
            { header: 'Schedule - N', field: 'ScheduleNCost', filterType: 'text', dataType: 'amount' },
            { header: 'Derivative', field: 'Derivative', filterType: 'text', dataType: 'amount' }
          ];
          break;        
      default:
        columns = cols;
        break;
    }
    return columns;
  }

  const exportExcel = async () => {
    setLoadingButton(true);
    var appraisalsArr: any[] = [];
    appraisalsArr = filterModel?.items?.map((appraisalsFilter: any) => {
      if (appraisalsFilter?.value !== undefined) {
        return {
          identity: appraisalsFilter?.field,
          matchMode: "in",
          value: appraisalsFilter?.value,
        };
      }
    });

    var url = AppraisalReviewServiceURL + "/Appraisals/ExportToExcelAppraisalsByViewIdAndFilters";

    var lazyLoadEventparameter = {
      filters: appraisalsArr,
      first: paginationModel.pageSize * paginationModel.page,
      rows: paginationModel.pageSize,
      sortOrder: sortColumnType.current,
      sortField: sortColumn.current,
      filterConditionalOperator: filterModel?.logicOperator,
    };
    var payload = {
      lazyLoadEventparam: lazyLoadEventparameter,
      viewName: AppraisalViewName.current,
      applicationUserEmail: currentUserData.email
    }

    var dataForExcel: any;
    await postApiCall(url, payload, ServiceName.APPRAISALREVIEW).then((data: any) => {

      dataForExcel = data.result;

    });

    var columns:any[];

    if (AppraisalViewName.current != "Accounting") {
      columns = getColumnsAsPerView(AppraisalViewName.current);
    } else {
      columns = cols;
    }
  if(dataForExcel.length != 0){
    AssetExport(dataForExcel, columns, "Appraisal");
  }
  else{
    alert("No Data Available To Download")
  }
    setLoadingButton(false);
  };

  const exportAccountingAsset = async () => {
    setExportLoadingButton(true);
    var url = AppraisalReviewServiceURL + `/Appraisals/data/assets/${viewNameAndId[AppraisalViewName.current]}`;
    var dataForExcel: any;
    var exportdata: any;
    var columnsDetails: any;
    await getApiCall(url, ServiceName.APPRAISALREVIEW).then((data: any) => {

      exportdata = data.result.assets;
      columnsDetails = data.result.columnsDetails;

    });

    if(exportdata.length != 0){
      AssetExport(exportdata, columnsDetails, "Assets");
    }
    else{
      alert("No Data Available To Download")
    }
    setExportLoadingButton(false);
  }


  const GetHeaderRow = (gridColumns: any[]): any => {
    let tableHeader = {};
    gridColumns.forEach(colConfig => {
      tableHeader[colConfig['header']] = colConfig['header'];
    });
    return tableHeader;
  }


  const SaveAsExcelFile = (buffer: any, fileName: string): void => {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    const datetime = dayjs(new Date()).format("MMMDDYY_HHmmss");
    FileSaver.saveAs(data, fileName + '_export_' + datetime + EXCEL_EXTENSION);
  }

  const GenerateExcelData = (gridColumns: any[], gridData: any[]): any[] => {
    //debugger;
    const exportData: any[] = [];

    //add table heading
    exportData.push(GetHeaderRow(gridColumns));

    //add grid data
    gridData.forEach(dataRow => {
      let newRow: any = {};
      gridColumns.forEach(colConfig => {
        //format column value

        const colValue = dataRow[colConfig['field']];
        switch (colConfig.dataType) {
          case 'date':
          case 'datetime':
            newRow[colConfig['header']] = colValue == null ? null : new Date(colValue);
            break;
          case 'percent':
            newRow[colConfig['header']] = colValue / 100;
            break;
          default:
            newRow[colConfig['header']] = colValue;
            break;
        }
      });
      exportData.push(newRow);
    });
    return exportData;
  }

  const GetColumnWidths = (gridColumns: any[]): any[] => {
    return gridColumns.map(() => ({ 'wpx': 150 }));
  }
  const AssetExport = (data: any[], columnNames: any[], fileNamePrefix: string) => {
    const excelData: any[] = GenerateExcelData(columnNames, data);
    let worksheet = XLSX.utils.json_to_sheet(excelData, { skipHeader: true });
    worksheet = FormatWorkSheetData(worksheet, data.length + 1, columnNames);
    worksheet['!cols'] = GetColumnWidths(columnNames);
    worksheet['!autofilter'] = { ref: 'A1:' + XLSX.utils.encode_col(data.length - 1) + '1' };
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    SaveAsExcelFile(excelBuffer, fileNamePrefix);

  }

  const FormatWorkSheetData = (worksheet: XLSX.WorkSheet, dataRowCount: number, columns: any = ""): XLSX.WorkSheet => {
    //get columns to be formatted
    var columnsToBeFormatted;
    columnsToBeFormatted = GetColumnsToBeFormatted(columns);

    const formatColCount = columnsToBeFormatted.length;
    for (let rowIndex = 1; rowIndex <= dataRowCount; rowIndex++) {
      for (let colIndex = 0; colIndex < formatColCount; colIndex++) {
        const cellAddress = columnsToBeFormatted[colIndex].excelColumn + rowIndex.toString();
        let cell = worksheet[cellAddress];
        if (!cell || cell.t != 'n') continue; // only format numeric cells
        cell.z = columnsToBeFormatted[colIndex].format;
      }
    }
    return worksheet;
  }
  const GetColumnsToBeFormatted = (columns: any): any[] => {
    const ExcelFormatters = {
      date: 'mm/dd/yyyy;@',
      datetime: 'mm/dd/yyyy hh:mm:ss;@',
      percent: '0.00%',
      amount: '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)'
    };

    //get column indices to be formatted
    const columnsToBeFormatted: any[] = [];
    for (let index = 0; index < columns.length; index++) {
      const element = columns[index];
      if (element && ExcelFormatters[element.dataType]) {
        columnsToBeFormatted.push({
          excelColumn: XLSX.utils.encode_col(index),
          format: ExcelFormatters[element.dataType],
          dataType: element.dataType
        });
      }
    }
    return columnsToBeFormatted;
  }



  const handleDashboardViewChange = (event: React.SyntheticEvent, newValue: string) => {
    // setFilterModel({ items: [] });
    let defaultFilterModel = { items: [] };
    setSelectedOptions({});
    sessionStorage.setItem('sessionUSFilterObject', JSON.stringify({ items: [] }));

    AppraisalViewName.current = newValue;
    sessionStorage.setItem("SessionUSAppraisalDashboardView", newValue);
    setValue(newValue);

    const dashboardSavedFilterModel = localStorage.getItem(AppraisalViewName.current);
    console.log("dashboardSavedFilterModel", dashboardSavedFilterModel)
    if (dashboardSavedFilterModel) {
      const parsedFilterModel = JSON.parse(dashboardSavedFilterModel);
      fetchData(paginationModel, parsedFilterModel);
      setFilterModel(parsedFilterModel);
      let options = {};
      parsedFilterModel.items?.forEach((item) => {
        options = {
          ...options, ...{
            [item.field]: item.value,
          }
        };
      });
      setSelectedOptions(options);
    } else {
      fetchData(paginationModel, defaultFilterModel);
      setFilterModel(defaultFilterModel);
      setSelectedOptions({});
    }
  };

  const fetchDefaultView = async () => {
    console.log("fetching")
    var appraisalViewURL = AppraisalReviewServiceURL + "/appraisals/Views?emailAddress=" + currentUserData?.email?.toLowerCase();
    await getApiCall(appraisalViewURL, ServiceName.APPRAISALREVIEW).then((appraisalView: any) => {
      // console.log(appraisalView);
      var defaultview = appraisalView.result[0].displayName;
      // console.log(defaultview);
      setValue(defaultview);
      sessionStorage.setItem("SessionUSAppraisalDashboardView", defaultview);
      AppraisalViewName.current = defaultview;
    });
  }


  useEffect(() => {
    // Access initial value from session storage
    var dashboardView = sessionStorage.getItem("SessionUSAppraisalDashboardView");

    if (dashboardView == null) {
      //set default
      fetchDefaultView();
      fetchData(paginationModel, { items: [] });
      console.log("fetching")
    } else {
      console.log("fetching");
      AppraisalViewName.current = dashboardView;
      setValue(dashboardView);

      // // get filters and set filter object
      // var filtersobj = sessionStorage.getItem("sessionUSFilterObject")
      // if (filtersobj !== null) {
      //   var filterObject = JSON.parse(filtersobj);
      //   setFilterModel(filterObject);
      //   setValue(dashboardView);
      //   fetchData(paginationModel, filterObject);
      // }
      // else {
      //   fetchData(paginationModel, filterModel);
      // }

      const defaultFilterModel = { items: [] };

      const dashboardSavedFilterModel = localStorage.getItem(AppraisalViewName.current);
      console.log("dashboardSavedFilterModel", dashboardSavedFilterModel)
      if (dashboardSavedFilterModel) {
        const parsedFilterModel = JSON.parse(dashboardSavedFilterModel);
        fetchData(paginationModel, parsedFilterModel);
        setFilterModel(parsedFilterModel);
        let options = {};
        parsedFilterModel.items?.forEach((item) => {
          options = {
            ...options, ...{
              [item.field]: item.value,
            }
          };
        });
        setSelectedOptions(options);
      } else {
        fetchData(paginationModel, defaultFilterModel);
        setFilterModel(defaultFilterModel);
        setSelectedOptions({});
      }

    }
  }, []);


  const clearAllFilters = () => {
    sessionStorage.removeItem("sessionUSFilterObject");
    setFilterModel({ items: [] });
    fetchData(paginationModel, { items: [] });
    localStorage.removeItem(AppraisalViewName.current);
    setSelectedOptions({});
  }


  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        {!loadingButton ? <Button startIcon={<FileDownloadIcon />} variant="text" onClick={exportExcel} size="medium" sx={{ ml: 2 }}>
          Export
        </Button> :
          <LoadingButton
            loading
            loadingPosition="start"
            startIcon={<FileDownloadIcon />}
            variant="text"
          >Export</LoadingButton>}
        {/* {AppraisalViewName.current === "Accounting" ? */}
          <>{!exportLoadingButton ? <Button startIcon={<FileDownloadIcon />} variant="text" onClick={exportAccountingAsset} size="medium" sx={{ ml: 2 }}>
            ASSET EXPORT
          </Button> :
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<FileDownloadIcon />}
              variant="text"
            >ASSET EXPORT</LoadingButton>}</> 
            {/* : <></>} */}
        {/* <GridToolbarFilterButton /> */}
        <Button onClick={clearAllFilters}>Clear All Filters</Button>
        {(AppraisalViewName.current == "To be Archived Appraisals" && rowSelectionModel.length !== 0) && <Button sx={{ textTransform: "none" }}
          variant="text"
          startIcon={<GridDeleteIcon />}
          onClick={openConfirmBox}
        >
          Delete & Archive
        </Button>}
      </GridToolbarContainer>
    );
  };

  const openConfirmBox = () => {
    setOpenDialog(true);
  };

  const DeleteAppraisal = () => {

    var ids: string[] = [];

    if (singleDelete.current) {
      ids.push(toBeDeleteId);
    } else {
      rowSelectionModel.forEach((id: any) => {
        ids.push(id.toString());
      })
    }
    // console.log(ids);
    try {
      setOpenDialog(false);
      setLoading(true);
      postApiCall(
        AppraisalReviewServiceURL + "/appraisals/DeleteAndArchiveAppraisal",
        ids,
        ServiceName.APPRAISALREVIEW
      )
        .then((res: any) => {
          setIsSuccess({
            isSuccess: true,
            message: "Appraisal record(s) has been Deleted",
          });
          var usAppraisals = [...usAppraisal];
          var count = 0;
          ids.forEach((id: string) => {
            const i = usAppraisals.findIndex((data: any) => data.id == id);
            count++;
            usAppraisals.splice(i, 1);
            // console.log(usAppraisals.splice(i,1));

          })
          setRowCount(rowCount - count);
          setUsAppraisal(usAppraisals);
          // if (singleDelete.current) {

          //   userRolesData.splice(userRolesData.findIndex((data:any) => data.id == toBeDeleteId),1)
          //   ids.push(toBeDeleteId);
          // } else {
          //   rowSelectionModel.forEach((id: any) => {
          //     ids.push(id.toString());
          //   })
          // }
          // userRolesData

        })
        .catch((error: any) => {
          console.log(error);
          setIsError({
            isError: true,
            message: error.response?.data.responseException.exceptionMessage,
          });
        });
    } catch (error) {
      console.log(error);
    } finally {
      if (singleDelete.current) {
        singleDelete.current = false;
      }
      wait(1000).then(() => {
        setLoading(false);
      });
      setIsSuccess({
        isSuccess: false,
        message: "",
      });
      setIsError({
        isError: false,
        message: "",
      });
    }
  };

  const closeDialog = () => {
    setToBeDeleteId("");
    setOpenDialog(false);
  };


  return (
    <Container maxWidth={false} className="dashboard-wrap">
      {
        <AlertDialog
          isOpen={openDialog}
          handleClose={closeDialog}
          onConfirm={DeleteAppraisal}
          title={"Attention"}
          message={"Are you sure you want to delete this appraisal record?"}
        />
      }
      {isError.isError && (
        <ToastMessage message={isError.message} severity="error" />
      )}
      {isSuccess.isSuccess && (
        <ToastMessage message={isSuccess.message} severity="success" />
      )}
      <Stack direction="row" spacing={2} className="user-role-action-btn">
        <div></div>
      </Stack>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleDashboardViewChange}
              aria-label="Appraisals Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              {appraisalView}
            </TabList>
          </Box>
          <TabPanel ref={ref} value="My Appraisals">
            {
              // <div style={{ height: 600, width: '100%' }}>
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsMyAppraisal}
                paginationModel={paginationModel}
                columnHeaderHeight={48}
                headerFilters
                headerFilterHeight={48}
                paginationMode="server"
                filterMode="server"
                sortingMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                onSortModelChange={(model: GridSortModel) => handelSortModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
              // </div>
            }
          </TabPanel>

          <TabPanel value="All Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsAllAppraisal}
                headerFilters
                paginationModel={paginationModel}
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                paginationMode="server"
                filterMode="server"
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="My Posted Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsMyPostedAppraisal}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="Accounting">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsAccounting}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="Current Month - Posted Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsCurrentMonthPostedAppraisal}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="All Posted Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsAllPostedAppraisal}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="Scheduled Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",
                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // },
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsScheduledAppraisal}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                disableRowSelectionOnClick={true}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              />
            }
          </TabPanel>
          <TabPanel value="To be Archived Appraisals">
            {
              <DataGridPro
                sx={{
                  backgroundColor: "white",

                  "& .MuiDataGrid-sortIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-filterIcon": {
                    color: "#253746",
                  },
                  "& .MuiDataGrid-headerFilterRow": {
                    borderColorr: "white",
                    background: "white"
                  },
                  '& .MuiDataGrid-cell': {
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.5rem',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'file-start',
                    marginBottom: '5px',
                    textAlign: 'left',
                  },
                  '& .MuiDataGrid-columnSeparator': {
                    visibility: 'visible'
                  },
                  // "& .MuiDataGrid-headerFilterRow":{
                  //   backgroundColor: "white !important"
                  // }---,
                  height: 600,
                }}
                getRowId={(row: any) => row.appraisalId}
                rows={usAppraisal}
                rowCount={rowCount}
                columns={columnsToBeArchivedAppraisal}
                headerFilters
                paginationModel={paginationModel}
                paginationMode="server"
                filterMode="server"
                pageSizeOptions={[10, 25, 50]}
                // rowHeight={40}
                getRowHeight={() => 'auto'}
                onPaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                onFilterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                slots={{
                  toolbar: CustomToolbar,
                  //noRowsOverlay: CustomDataGridNoRowOverlay,
                }}
                pagination
                checkboxSelection
                onRowSelectionModelChange={(newRowSelectionModel: any) => {

                  setRowSelectionModel(newRowSelectionModel);
                }}
                rowSelectionModel={rowSelectionModel}
                showCellVerticalBorder={true}
                showColumnVerticalBorder={true}
                getRowClassName={(params: GridRowClassNameParams) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
              // autosizeOnMount
              />
            }
          </TabPanel>

        </TabContext>
      </Box>
    </Container>
  );
};
